/**
 * 로그인 만료 안내 — 판매자 대시보드의 인증 콜백과 머리 버튼(임베드 주소 요청) 실패가 같은
 * 문구·같은 토스트 id 를 써서 한 번만 뜨게 한다(A3-15·V-15).
 */
export const SESSION_EXPIRED_TOAST_ID = "vendor-session-expired";
export const SESSION_EXPIRED_MESSAGE =
  "로그인이 만료되었습니다. 다시 로그인해주세요.";
